// Сборка колоды по рецепту "1 Лег + 2 Эпика + 6 Редких + 15 Обычных = 24 карты".
// В колоду идут юниты И Действия (action). Влияние и mod не идут (они вне колоды).
// Действия упорядочены первыми в каждой редкости — round-robin гарантирует, что каждое
// Действие получит как минимум одну копию, прежде чем юниты заполнят остальные слоты.
// Лимит копий каждой карты — поле deck_limit из xlsx (common=3, rare=2, epic/legendary=1).

import { cards as cardsDeus } from './cards-deus.js';
import { cards as cardsSyntetics } from './cards-syntetics.js';
import { cards as cardsGlobal } from './cards-global.js';
import { cards as cardsLivlife } from './cards-livlife.js';
import { cards as cardsNeutral } from './cards-neutral.js';

const ALL_CARDS = {
  deus: cardsDeus,
  syntetics: cardsSyntetics,
  global: cardsGlobal,
  livlife: cardsLivlife,
  neutral: cardsNeutral
};

const DECK_RECIPE = { legendary: 1, epic: 2, rare: 6, common: 15 };

// В.1.a-fix3: фильтр снят — все карты Глобала из xlsx подгружаются с базовыми
// статами и keyword'ами. Способности (passive/order/active/trigger/deathrattle/
// aura/oneshot/summon) игнорируются и логируются warning'ом при выставлении.
// Реальная реализация — В.1.b … В.1.h.

export function getFactionCards(factionId) {
  return ALL_CARDS[factionId] || [];
}

// Возвращает массив шаблонов для колоды данной фракции.
export function buildDeckTemplates(factionId) {
  const pool = getFactionCards(factionId).filter(c =>
    c.type === 'unit' || c.type === 'action'
  );
  const result = [];

  for (const [rarity, want] of Object.entries(DECK_RECIPE)) {
    const candidates = pool.filter(c => c.rarity === rarity);
    if (candidates.length === 0) {
      console.warn(`[deck:${factionId}] нет карт редкости ${rarity}`);
      continue;
    }

    // Action-карты идут первыми в порядке итерации — это гарантирует им хотя бы одну
    // копию даже когда юнитов больше, чем слотов в редкости.
    const actions = candidates.filter(c => c.type === 'action');
    const units = candidates.filter(c => c.type === 'unit');
    const ordered = [...actions, ...units];

    // Round-robin: пасс берёт по 1 копии каждого вида (если deck_limit позволяет),
    // потом второй пасс берёт 2-е копии и т.д. Останавливаемся, когда добрали want
    // слотов или когда никто из видов больше не может дать копию.
    const counts = new Map();
    let added = 0;
    let progressed = true;
    while (added < want && progressed) {
      progressed = false;
      for (const card of ordered) {
        if (added >= want) break;
        const taken = counts.get(card.id) || 0;
        const limit = card.deck_limit ?? 3;
        if (taken < limit) {
          result.push(card);
          counts.set(card.id, taken + 1);
          added++;
          progressed = true;
        }
      }
    }
    if (added < want) {
      console.warn(`[deck:${factionId}] не хватило ${rarity}: нужно ${want}, набралось ${added}`);
    }
  }
  return result;
}
